import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild, inject } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms'
import { NgbActiveOffcanvas, NgbNav, NgbNavModule, NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap'
import { ToastrService } from 'ngx-toastr'

import { NgSelectModule } from '@ng-select/ng-select'
import { CardComponent } from '../../card/card.component'
import { EmptyComponent } from '../../empty/empty.component'
import { ButtonComponent } from '../../form-elements/button/button.component'
import { InputComponent } from '../../form-elements/input/input.component'
import { LabelComponent } from '../../form-elements/label/label.component'
import { InfoBoxComponent } from '../../info-box/info-box.component'
import { SmartquoteBespokeFavouriteService } from 'src/app/core/services/smartquote/smartquote-bespoke-favourite.service'
import { Observable } from 'rxjs'
import { PaginatedList } from 'src/app/shared/interfaces/api-response/api-paginated-list.interface'
import { SmartQuoteBespokeFavouriteFilter } from 'src/app/shared/interfaces/smartquote-bespoke-favourite/smartquote-bespoke-favourite-filter.interface'
import { SmartQuoteBespokeFavourite } from 'src/app/shared/interfaces/smartquote-bespoke-favourite/smartquote-bespoke-favourite.interface'
import { RouterModule } from '@angular/router'
import { SwitchComponent } from '../../form-elements/switch/switch.component'
import { InputMoneyComponent } from '../../form-elements/input-money/input-money.component'

@Component({
    selector: 'sf-smartquote-bespoke-product-search',
    imports: [
        CommonModule,
        ReactiveFormsModule,
        NgbPaginationModule,
        NgSelectModule,
        RouterModule,
        NgbNavModule,
        ButtonComponent,
        LabelComponent,
        InfoBoxComponent,
        CardComponent,
        EmptyComponent,
        InputComponent,
        SwitchComponent,
        InputMoneyComponent,
    ],
    templateUrl: './smartquote-bespoke-product-search.component.html',
    styleUrls: ['./smartquote-bespoke-product-search.component.scss'],
})
export class SmartquoteBespokeProductSearchComponent implements OnInit {
    activeOffcanvas: NgbActiveOffcanvas = inject(NgbActiveOffcanvas)
    fb = inject(FormBuilder)
    smartquoteBespokeProductService = inject(SmartquoteBespokeFavouriteService)
    toastr = inject(ToastrService)

    filter: SmartQuoteBespokeFavouriteFilter = {
        pageNumber: 1,
        pageSize: 10,
        searchTerm: '',
    }

    bespokePartForm = this.fb.group({
        bespokeDescription: this.fb.nonNullable.control<string>('', [Validators.required, Validators.maxLength(500)]),
        bespokeMpn: this.fb.control<string | null>(null, [Validators.maxLength(50)]),
        bespokeCost: this.fb.nonNullable.control<number>(0, [Validators.required]),
        create: this.fb.control<boolean>(false),
    })

    products$!: Observable<PaginatedList<SmartQuoteBespokeFavourite>>
    selectedPart: SmartQuoteBespokeFavourite | null = null
    @ViewChild('selectedPartElement') selectedPartElement!: ElementRef

    @Output() partSelected = new EventEmitter<SmartQuoteBespokeFavourite>()

    ngOnInit(): void {
        this.products$ = this.smartquoteBespokeProductService.getBespokeFavourites(this.filter)
    }

    onPageChange(page: number): void {
        this.filter.pageNumber = page
        this.products$ = this.smartquoteBespokeProductService.getBespokeFavourites(this.filter)
    }

    onPartSelect(part: SmartQuoteBespokeFavourite): void {
        this.selectedPart = part
        setTimeout(() => {
            this.selectedPartElement.nativeElement.scrollIntoView({ behavior: 'smooth' })
        }, 100)
    }

    confirmBespokePart(): void {
        if (this.bespokePartForm.invalid) {
            return
        }

        let bespokePart: SmartQuoteBespokeFavourite = {
            id: 0,
            cost: this.bespokePartForm.controls.bespokeCost.value,
            description: this.bespokePartForm.controls.bespokeDescription.value,
            mpn: this.bespokePartForm.controls.bespokeMpn.value ?? '',
        }

        if (this.bespokePartForm.controls.create.value) {
            this.smartquoteBespokeProductService.createBespokeFavourite(bespokePart).subscribe({
                next: (response) => {
                    this.partSelected.emit(response)
                    this.activeOffcanvas.close()
                },
            })
        } else {
            this.partSelected.emit(bespokePart)
            this.activeOffcanvas.close()
        }
    }

    confirmPart(): void {
        this.partSelected.emit(this.selectedPart!)
        this.activeOffcanvas.close()
    }

    dismiss(): void {
        this.activeOffcanvas.dismiss()
    }

    close(): void {
        this.activeOffcanvas.close()
    }
}
